// projekt/frontend/src/App.js

import React, { useState, useEffect, useRef } from 'react';
import './Kalkulator.css';
import { FiCalendar, FiDollarSign, FiUserCheck, FiTool, FiMoon, FiSun } from 'react-icons/fi';

function App() {
  const printRef = useRef();

  const handlePrint = () => {
    window.print();
  };
  // === Tema (dark/light) ===
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('theme') === 'dark';
    setDarkMode(saved);
    document.documentElement.setAttribute('data-theme', saved ? 'dark' : 'light');
  }, []);

  const toggleTheme = () => {
    const mode = !darkMode;
    setDarkMode(mode);
    document.documentElement.setAttribute('data-theme', mode ? 'dark' : 'light');
    localStorage.setItem('theme', mode ? 'dark' : 'light');
  };

  // === STATE za polja forme ===
  
  // Mjesec se sada automatski postavlja na prethodni mjesec
  const [mjesec, setMjesec] = useState(() => {
    const now = new Date();
    const currentMonth = now.getMonth() + 1; // getMonth() vraća 0-11, pa dodajemo 1
    return currentMonth === 1 ? '12' : (currentMonth - 1).toString();
  });

  const [staz, setStaz] = useState(''); 

  // Reverzna kalkulacija
  const [unosTip, setUnosTip] = useState('brutoPlata');
  const [brutoPlata, setBrutoPlata] = useState('');
  const [netoPlata, setNetoPlata] = useState('');
  const [solidarnostNeto, setSolidarnostNeto] = useState('');
  const [brutoUkupno, setBrutoUkupno] = useState('');

  // Ostala polja
  const [neplaceno, setNeplaceno] = useState('');
  const [placeno, setPlaceno] = useState('');
  const [neodradeniSati, setNeodradeniSati] = useState('');
  const [dnevnice, setDnevnice] = useState('');
  const [topliObrok, setTopliObrok] = useState('');
  const [licniOdbitak, setLicniOdbitak] = useState('');
  const [umanjenje, setUmanjenje] = useState('');

  // Dodatni sati
  const [imaPreko, setImaPreko] = useState(false);
  const [prekovremeni, setPrekovremeni] = useState(false);
  const [prekovremeniSati, setPrekovremeniSati] = useState('');
  const [prekovremeniProc, setPrekovremeniProc] = useState('');

  const [nocni, setNocni] = useState(false);
  const [nocniSati, setNocniSati] = useState('');
  const [nocniProc, setNocniProc] = useState('');

  const [praznik, setPraznik] = useState(false);
  const [praznikSati, setPraznikSati] = useState('');
  const [praznikProc, setPraznikProc] = useState('');

  // === STATE za poruke gresaka ===
  const [errors, setErrors] = useState({
    mjesec: '',
    staz: '',
    brutoPlata: '',
    netoPlata: '',
    solidarnostNeto: '',
    brutoUkupno: '',
    neplaceno: '',
    placeno: '',
    neodradeniSati: '',
    dnevnice: '',
    topliObrok: '',
    licniOdbitak: '',
    umanjenje: '',
    prekovremeniSati: '',
    prekovremeniProc: '',
    nocniSati: '',
    nocniProc: '',
    praznikSati: '',
    praznikProc: '',
  });

  // === STATE za rezultate i loading/error ===
  const [rezultati, setRezultati_fbih] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  // Ref za kontejner rezultata
  const resultsRef = useRef(null);

  // === DEFINICIJA PRESETA (Minimalne plate 2026) ===
  // Vrijednosti su primjeri - prilagodite ih tačnom zakonu ako je drugačije.
  const presetPlate = [
    { 
      label: 'Kliknite za automatski unos minimalnog iznosa', 
      neto: '1027.00',    // Primjer Neto
      bruto: '1605.48'    // Primjer Bruto
    },
  ];

  // Funkcija za primjenu preseta
  const applyPreset = (netoVal, brutoVal) => {
    if (unosTip === 'netoPlata') {
      setNetoPlata(netoVal);
      validateField('netoPlata', netoVal);
      setBrutoPlata(''); // Čistimo drugo polje
      setErrors(prev => ({ ...prev, brutoPlata: '' }));
    } else {
      setBrutoPlata(brutoVal);
      validateField('brutoPlata', brutoVal);
      setNetoPlata(''); // Čistimo drugo polje
      setErrors(prev => ({ ...prev, netoPlata: '' }));
    }
  };

  // === Funkcija za validaciju polja ===
  const validateField = (fieldName, value) => {
    let msg = '';

    if (
      ['brutoPlata', 'netoPlata', 'solidarnostNeto', 'brutoUkupno'].includes(fieldName) &&
      unosTip !== fieldName
    ) {
      setErrors(prev => ({ ...prev, [fieldName]: '' }));
      return;
    }

    switch (fieldName) {
      case 'mjesec':
        if (value.trim() === '') {
          msg = 'Unesite mjesec (1–12).';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 1 || num > 12) {
            msg = 'Mjesec mora biti broj između 1 i 12.';
          }
        }
        break;

      case 'staz':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Staž mora biti nenegativan broj.';
          }
        }
        break;

      case 'brutoPlata':
        if (value.trim() === '') {
          msg = 'Upišite bruto osnovnu platu.';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Bruto plata mora biti nenegativan broj.';
          }
        }
        break;

      case 'netoPlata':
        if (value.trim() === '') {
          msg = 'Upišite neto platu.';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Neto plata mora biti nenegativan broj.';
          }
        }
        break;

      case 'solidarnostNeto':
        if (value.trim() === '') {
          msg = 'Upišite neto nakon solidarnog doprinosa.';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Solidarnost neto mora biti nenegativan broj.';
          }
        }
        break;

      case 'brutoUkupno':
        if (value.trim() === '') {
          msg = 'Upišite ukupni bruto trošak.';
        } else {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Bruto ukupno mora biti nenegativan broj.';
          }
        }
        break;

      case 'neplaceno':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Neplaćeni dani moraju biti nenegativan broj.';
          }
        }
        break;

      case 'placeno':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Plaćeno odsustvo mora biti nenegativan broj.';
          }
        }
        break;

      case 'neodradeniSati':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Unesite broj neodrađenih sati ≥ 0.';
          }
        }
        break;

      case 'dnevnice':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Broj dnevnica mora biti nenegativan broj.';
          }
        }
        break;

      case 'topliObrok':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Iznos toplog obroka mora biti nenegativan broj.';
          }
        }
        break;

      case 'licniOdbitak':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Lični odbitak mora biti nenegativan broj.';
          }
        }
        break;

      case 'umanjenje':
        if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Iznos umanjenja mora biti nenegativan broj.';
          }
        }
        break;

      case 'prekovremeniSati':
        if (prekovremeni && value.trim() === '') {
          msg = 'Upišite broj sati prekovremenog rada.';
        } else if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Prekovremeni sati moraju biti nenegativan broj.';
          }
        }
        break;

      case 'prekovremeniProc':
        if (prekovremeni && value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Procenat prekovremenog rada mora biti nenegativan.';
          }
        }
        break;

      case 'nocniSati':
        if (nocni && value.trim() === '') {
          msg = 'Upišite broj sati noćnog rada.';
        } else if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Noćni sati moraju biti nenegativan broj.';
          }
        }
        break;

      case 'nocniProc':
        if (nocni && value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Procenat noćnog rada mora biti nenegativan.';
          }
        }
        break;

      case 'praznikSati':
        if (praznik && value.trim() === '') {
          msg = 'Upišite broj sati rada za praznik.';
        } else if (value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Praznični sati moraju biti nenegativan broj.';
          }
        }
        break;

      case 'praznikProc':
        if (praznik && value !== '') {
          const num = Number(value);
          if (isNaN(num) || num < 0) {
            msg = 'Procenat rada za praznik mora biti nenegativan.';
          }
        }
        break;

      default:
        break;
    }

    setErrors(prev => ({ ...prev, [fieldName]: msg }));
  };

  // === Provjera valjanosti forme ===
  const isFormValid = () => {
    if (
      errors.mjesec ||
      mjesec.trim() === ''
    ) {
      return false;
    }

    const odabran = {
      brutoPlata,
      netoPlata,
      solidarnostNeto,
      brutoUkupno,
    }[unosTip];
    if (odabran.trim() === '') return false;
    if (errors[unosTip]) return false;

    for (let key of Object.keys(errors)) {
      if (errors[key]) return false;
    }
    return true;
  };

  // === useEffect za slanje podataka i dohvat rezultata ===
  useEffect(() => {
    validateField('mjesec', mjesec);
    validateField('staz', staz);

    validateField('brutoPlata', brutoPlata);
    validateField('netoPlata', netoPlata);
    validateField('solidarnostNeto', solidarnostNeto);
    validateField('brutoUkupno', brutoUkupno);

    validateField('neplaceno', neplaceno);
    validateField('placeno', placeno);
    validateField('neodradeniSati', neodradeniSati);
    validateField('dnevnice', dnevnice);
    validateField('topliObrok', topliObrok);
    validateField('licniOdbitak', licniOdbitak);
    validateField('umanjenje', umanjenje);
    validateField('prekovremeniSati', prekovremeniSati);
    validateField('prekovremeniProc', prekovremeniProc);
    validateField('nocniSati', nocniSati);
    validateField('nocniProc', nocniProc);
    validateField('praznikSati', praznikSati);
    validateField('praznikProc', praznikProc);

    if (!isFormValid()) {
      setRezultati_fbih(null);
      return;
    }

    const payload = {
      mjesec: parseInt(mjesec.replace(',', '.'), 10),
      godina: 2026, // Fiksna godina
      staz: staz.trim() === '' ? 0 : parseInt(staz.replace(',', '.'), 10),

      neplaceno: neplaceno.trim() === '' ? null : parseFloat(neplaceno.replace(',', '.')),
      placeno: placeno.trim() === '' ? null : parseFloat(placeno.replace(',', '.')),
      neodrađeni_sati:
        neodradeniSati.trim() === '' ? null : parseFloat(neodradeniSati.replace(',', '.')),
      dnevnice: dnevnice.trim() === '' ? null : parseFloat(dnevnice.replace(',', '.')),
      topli_obrok_input:
        topliObrok.trim() === '' ? null : parseFloat(topliObrok.replace(',', '.')),
      licni_odbitak_input:
        licniOdbitak.trim() === '' ? null : parseFloat(licniOdbitak.replace(',', '.')),
      umanjenje: umanjenje.trim() === '' ? null : parseFloat(umanjenje.replace(',', '.')),

      ima_preko: imaPreko,
      prekovremeni: prekovremeni,
      prekovremeni_sati:
        prekovremeniSati.trim() === '' ? null : parseFloat(prekovremeniSati.replace(',', '.')),
      prekovremeni_proc:
        prekovremeniProc.trim() === '' ? null : parseFloat(prekovremeniProc.replace(',', '.')),

      nocni: nocni,
      nocni_sati: nocniSati.trim() === '' ? null : parseFloat(nocniSati.replace(',', '.')),
      nocni_proc:
        nocniProc.trim() === '' ? null : parseFloat(nocniProc.replace(',', '.')),

      praznik: praznik,
      praznik_sati: praznikSati.trim() === '' ? null : parseFloat(praznikSati.replace(',', '.')),
      praznik_proc:
        praznikProc.trim() === '' ? null : parseFloat(praznikProc.replace(',', '.')),

      bruto_plata_input:
        unosTip === 'brutoPlata' && brutoPlata.trim() !== ''
          ? parseFloat(brutoPlata.replace(',', '.'))
          : null,
      neto_plata_input:
        unosTip === 'netoPlata' && netoPlata.trim() !== ''
          ? parseFloat(netoPlata.replace(',', '.'))
          : null,
      solidarnost_neto_input:
        unosTip === 'solidarnostNeto' && solidarnostNeto.trim() !== ''
          ? parseFloat(solidarnostNeto.replace(',', '.'))
          : null,
      bruto_ukupno_input:
        unosTip === 'brutoUkupno' && brutoUkupno.trim() !== ''
          ? parseFloat(brutoUkupno.replace(',', '.'))
          : null,
    };

    setLoading(true);
    setSubmitError(null);

    fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/calculate_fbih', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json();
          throw new Error(data.detail || 'Greška pri izračunu');
        }
        return res.json();
      })
      .then((data) => {
        setRezultati_fbih(data);
        setLoading(false);
      })
      .catch((e) => {
        setSubmitError(e.message);
        setRezultati_fbih(null);
        setLoading(false);
      });
  }, [
    mjesec,
    staz,
    unosTip,
    brutoPlata,
    netoPlata,
    solidarnostNeto,
    brutoUkupno,
    neplaceno,
    placeno,
    neodradeniSati,
    dnevnice,
    topliObrok,
    licniOdbitak,
    umanjenje,
    imaPreko,
    prekovremeni,
    prekovremeniSati,
    prekovremeniProc,
    nocni,
    nocniSati,
    nocniProc,
    praznik,
    praznikSati,
    praznikProc,
  ]);

  // === Pomoćne funkcije za prikaz ===
  const formatirajDatum = () => {
    const mm = mjesec.toString().padStart(2, '0');
    return `${mm}.2026.`;
  };

  const prikaziDane = (polje) => {
    return polje === '' ? 0 : parseInt(polje, 10);
  };

  const prikaziStaz = (polje) => {
    return polje === '' ? 0 : parseInt(polje, 10);
  };

  // === Funkcija za resetiranje polja ===
  const clearAll = () => {
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    setMjesec(currentMonth === 1 ? '12' : (currentMonth - 1).toString());
    
    setStaz('');
    setUnosTip('brutoPlata');
    setBrutoPlata('');
    setNetoPlata('');
    setSolidarnostNeto('');
    setBrutoUkupno('');
    setNeplaceno('');
    setPlaceno('');
    setNeodradeniSati('');
    setDnevnice('');
    setTopliObrok('');
    setLicniOdbitak('');
    setUmanjenje('');
    setImaPreko(false);
    setPrekovremeni(false);
    setPrekovremeniSati('');
    setPrekovremeniProc('');
    setNocni(false);
    setNocniSati('');
    setNocniProc('');
    setPraznik(false);
    setPraznikSati('');
    setPraznikProc('');
    setErrors({
      mjesec: '',
      staz: '',
      brutoPlata: '',
      netoPlata: '',
      solidarnostNeto: '',
      brutoUkupno: '',
      neplaceno: '',
      placeno: '',
      neodradeniSati: '',
      dnevnice: '',
      topliObrok: '',
      licniOdbitak: '',
      umanjenje: '',
      prekovremeniSati: '',
      prekovremeniProc: '',
      nocniSati: '',
      nocniProc: '',
      praznikSati: '',
      praznikProc: '',
    });
    setRezultati_fbih(null);
    setSubmitError(null);
  };

  return (
    <>
      {/* Naslov aplikacije */}
      <header className="app-header">
        <h1>
          Obračun plata i doprinosa u Federaciji BIH
          <br />
          (za puno radno vrijeme sa toplim obrokom, uvećanjima i odbicima)
        </h1>
      </header>

      <div className="container">
        {/* ==== LEVI STUPAC: FORMA ==== */}
        <div className="form-container card">
          {/* FORM HEADER */}
          <div className="form-header">
            <h2 className="section-title">Unos podataka</h2>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="button" className="clear-button" onClick={clearAll}>
                Obriši sve
              </button>
              <button type="button" className="clear-button" onClick={handlePrint}>Štampaj</button>
            </div>
          </div>

          {/* Sve polja u jednoj koloni */}
          <div className="field-group">
            <label htmlFor="mjesec" className="field-label">
              Mjesec<span className="required">*</span> (1–12):
            </label>
            <input
              type="text"
              id="mjesec"
              className={`field-input ${errors.mjesec ? 'shake' : ''}`}
              placeholder="npr. 7"
              value={mjesec}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setMjesec(v);
                validateField('mjesec', v);
              }}
              onBlur={(e) => validateField('mjesec', e.target.value.replace(',', '.'))}
            />
            {errors.mjesec && <div className="error-text">{errors.mjesec}</div>}
          </div>

          {/* DODATO POLJE: Godine staža */}
          <div className="field-group">
            <label htmlFor="staz" className="field-label">
              Godine staža (za obračun minulog rada):
            </label>
            <input
              type="text"
              id="staz"
              className={`field-input ${errors.staz ? 'shake' : ''}`}
              placeholder="npr. 10"
              value={staz}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setStaz(v);
                validateField('staz', v);
              }}
              onBlur={(e) => validateField('staz', e.target.value.replace(',', '.'))}
            />
            {errors.staz && <div className="error-text">{errors.staz}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="unosTip" className="field-label">
              Odaberite osnov za kalkulaciju:<span className="required">*</span>
            </label>
            <select
              id="unosTip"
              className="field-select"
              value={unosTip}
              onChange={(e) => {
                setUnosTip(e.target.value);
                setBrutoPlata('');
                setNetoPlata('');
                setSolidarnostNeto('');
                setBrutoUkupno('');
                setErrors(prev => ({
                  ...prev,
                  brutoPlata: '',
                  netoPlata: '',
                  solidarnostNeto: '',
                  brutoUkupno: '',
                }));
              }}
            >
              <option value="brutoPlata">Bruto osnovna plata</option>
              <option value="netoPlata">Neto plata</option>
            </select>
          </div>

          {/* NOVO: PRESET DUGMAD */}
          <div className="field-group">
            <label className="field-label">Brzi odabir (Minimalne plate 2026):</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '5px' }}>
              {presetPlate.map((preset, index) => (
                <button
                  key={index}
                  type="button"
                  className="clear-button" // Koristimo postojeću klasu ili napravimo novu
                  style={{ flex: '1 1 45%', fontSize: '0.85em', padding: '8px' }}
                  onClick={() => applyPreset(preset.neto, preset.bruto)}
                >
                  {preset.label}
                </button>
              ))}
            </div>
          </div>

          {unosTip === 'brutoPlata' && (
            <div className="field-group">
              <label htmlFor="brutoPlata" className="field-label">
                Bruto osnovna plata<span className="required">*</span>:
              </label>
              <input
                type="text"
                id="brutoPlata"
                className={`field-input ${errors.brutoPlata ? 'shake' : ''}`}
                placeholder="npr. 2500,00"
                value={brutoPlata}
                onChange={(e) => {
                  const v = e.target.value.replace(',', '.');
                  setBrutoPlata(v);
                  validateField('brutoPlata', v);
                }}
                onBlur={(e) => validateField('brutoPlata', e.target.value.replace(',', '.'))}
              />
              {errors.brutoPlata && <div className="error-text">{errors.brutoPlata}</div>}
            </div>
          )}

          {unosTip === 'netoPlata' && (
            <div className="field-group">
              <label htmlFor="netoPlata" className="field-label">
                Neto plata<span className="required">*</span>:
              </label>
              <input
                type="text"
                id="netoPlata"
                className={`field-input ${errors.netoPlata ? 'shake' : ''}`}
                placeholder="npr. 1500,00"
                value={netoPlata}
                onChange={(e) => {
                  const v = e.target.value.replace(',', '.');
                  setNetoPlata(v);
                  validateField('netoPlata', v);
                }}
                onBlur={(e) => validateField('netoPlata', e.target.value.replace(',', '.'))}
              />
              {errors.netoPlata && <div className="error-text">{errors.netoPlata}</div>}
            </div>
          )}

          <div className="field-group">
            <label htmlFor="topliObrok" className="field-label">
              Topli obrok PO DANU: <br /> (neoporezivi topli obrok u FBIH je do 15.00 KM po danu)
            </label>
            <input
              type="text"
              id="topliObrok"
              className={`field-input ${errors.topliObrok ? 'shake' : ''}`}
              placeholder="npr. 0"
              value={topliObrok}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setTopliObrok(v);
                validateField('topliObrok', v);
              }}
              onBlur={(e) => validateField('topliObrok', e.target.value.replace(',', '.'))}
            />
            {errors.topliObrok && <div className="error-text">{errors.topliObrok}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="neplaceno" className="field-label">
              NEPLAĆENO odsustno: <br />(ili neodrađeni radni dani zbog kasnijeg stupanja u radni odnos (broj dana))
            </label>
            <input
              type="text"
              id="neplaceno"
              className={`field-input ${errors.neplaceno ? 'shake' : ''}`}
              placeholder="npr. 2"
              value={neplaceno}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setNeplaceno(v);
                validateField('neplaceno', v);
              }}
              onBlur={(e) => validateField('neplaceno', e.target.value.replace(',', '.'))}
            />
            {errors.neplaceno && <div className="error-text">{errors.neplaceno}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="placeno" className="field-label">
              PLAĆENO odsustvo: <br /> (npr. godišnji odmor ili neradni dani zbog praznika (broj dana))
            </label>
            <input
              type="text"
              id="placeno"
              className={`field-input ${errors.placeno ? 'shake' : ''}`}
              placeholder="npr. 1"
              value={placeno}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setPlaceno(v);
                validateField('placeno', v);
              }}
              onBlur={(e) => validateField('placeno', e.target.value.replace(',', '.'))}
            />
            {errors.placeno && <div className="error-text">{errors.placeno}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="neodradeniSati" className="field-label">
              Neodrađeni radni sati u mjesecu:<br /> (npr. zbog kašnjenja, ranijeg izlaska)
            </label>
            <input
              type="text"
              id="neodradeniSati"
              className={`field-input ${errors.neodradeniSati ? 'shake' : ''}`}
              placeholder="npr. 8"
              value={neodradeniSati}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setNeodradeniSati(v);
                validateField('neodradeniSati', v);
              }}
              onBlur={(e) => validateField('neodradeniSati', e.target.value.replace(',', '.'))}
            />
            {errors.neodradeniSati && <div className="error-text">{errors.neodradeniSati}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="dnevnice" className="field-label">
              Broj dana za koje je radniku isplaćena dnevnica:
            </label>
            <input
              type="text"
              id="dnevnice"
              className={`field-input ${errors.dnevnice ? 'shake' : ''}`}
              placeholder="npr. 10"
              value={dnevnice}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setDnevnice(v);
                validateField('dnevnice', v);
              }}
              onBlur={(e) => validateField('dnevnice', e.target.value.replace(',', '.'))}
            />
            {errors.dnevnice && <div className="error-text">{errors.dnevnice}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="licniOdbitak" className="field-label">
              Lični odbitak (ostavite prazno za 300 KM):
            </label>
            <input
              type="text"
              id="licniOdbitak"
              className={`field-input ${errors.licniOdbitak ? 'shake' : ''}`}
              placeholder="npr. 300,00"
              value={licniOdbitak}
              onChange={(e) => {
                const v = e.target.value.replace(',', '.');
                setLicniOdbitak(v);
                validateField('licniOdbitak', v);
              }}
              onBlur={(e) => validateField('licniOdbitak', e.target.value.replace(',', '.'))}
            />
            {errors.licniOdbitak && <div className="error-text">{errors.licniOdbitak}</div>}
          </div>

          <div className="field-group">
            <label htmlFor="imaPreko" className="field-label">
              Dodatni sati (prekovremeni, noćni, praznik)?
            </label>
            <select
              id="imaPreko"
              className="field-select"
              value={imaPreko ? 'da' : 'ne'}
              onChange={(e) => setImaPreko(e.target.value === 'da')}
            >
              <option value="ne">Ne</option>
              <option value="da">Da</option>
            </select>
          </div>

          {imaPreko && (
            <>
              {/* Prekovremeni rad */}
              <div className="field-group">
                <label htmlFor="prekovremeni" className="field-label">
                  Prekovremeni rad (da/ne):
                </label>
                <select
                  id="prekovremeni"
                  className="field-select"
                  value={prekovremeni ? 'da' : 'ne'}
                  onChange={(e) => {
                    const val = e.target.value === 'da';
                    setPrekovremeni(val);
                    if (!val) {
                      setErrors(prev => ({
                        ...prev,
                        prekovremeniSati: '',
                        prekovremeniProc: '',
                      }));
                      setPrekovremeniSati('');
                      setPrekovremeniProc('');
                    }
                  }}
                >
                  <option value="ne">Ne</option>
                  <option value="da">Da</option>
                </select>
              </div>
              {prekovremeni && (
                <>
                  <div className="field-group">
                    <label htmlFor="prekovremeniSati" className="field-label">
                      Broj sati prekovremenog rada<span className="required">*</span>:
                    </label>
                    <input
                      type="text"
                      id="prekovremeniSati"
                      className={`field-input ${errors.prekovremeniSati ? 'shake' : ''}`}
                      placeholder="npr. 10"
                      value={prekovremeniSati}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setPrekovremeniSati(v);
                        validateField('prekovremeniSati', v);
                      }}
                      onBlur={(e) =>
                        validateField('prekovremeniSati', e.target.value.replace(',', '.'))
                      }
                    />
                    {errors.prekovremeniSati && (
                      <div className="error-text">{errors.prekovremeniSati}</div>
                    )}
                  </div>
                  <div className="field-group">
                    <label htmlFor="prekovremeniProc" className="field-label">
                      Procenat uvećanja (ostavite prazno za 30%):
                    </label>
                    <input
                      type="text"
                      id="prekovremeniProc"
                      className={`field-input ${errors.prekovremeniProc ? 'shake' : ''}`}
                      placeholder="npr. 30"
                      value={prekovremeniProc}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setPrekovremeniProc(v);
                        validateField('prekovremeniProc', v);
                      }}
                      onBlur={(e) =>
                        validateField('prekovremeniProc', e.target.value.replace(',', '.'))
                      }
                    />
                    {errors.prekovremeniProc && (
                      <div className="error-text">{errors.prekovremeniProc}</div>
                    )}
                  </div>
                </>
              )}

              {/* Noćni rad */}
              <div className="field-group">
                <label htmlFor="nocni" className="field-label">
                  Noćni rad (da/ne):
                </label>
                <select
                  id="nocni"
                  className="field-select"
                  value={nocni ? 'da' : 'ne'}
                  onChange={(e) => {
                    const val = e.target.value === 'da';
                    setNocni(val);
                    if (!val) {
                      setErrors(prev => ({ ...prev, nocniSati: '', nocniProc: '' }));
                      setNocniSati('');
                      setNocniProc('');
                    }
                  }}
                >
                  <option value="ne">Ne</option>
                  <option value="da">Da</option>
                </select>
              </div>
              {nocni && (
                <>
                  <div className="field-group">
                    <label htmlFor="nocniSati" className="field-label">
                      Broj sati noćnog rada<span className="required">*</span>:
                    </label>
                    <input
                      type="text"
                      id="nocniSati"
                      className={`field-input ${errors.nocniSati ? 'shake' : ''}`}
                      placeholder="npr. 8"
                      value={nocniSati}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setNocniSati(v);
                        validateField('nocniSati', v);
                      }}
                      onBlur={(e) => validateField('nocniSati', e.target.value.replace(',', '.'))}
                    />
                    {errors.nocniSati && <div className="error-text">{errors.nocniSati}</div>}
                  </div>
                  <div className="field-group">
                    <label htmlFor="nocniProc" className="field-label">
                      Procenat uvećanja (ostavite prazno za 30%):
                    </label>
                    <input
                      type="text"
                      id="nocniProc"
                      className={`field-input ${errors.nocniProc ? 'shake' : ''}`}
                      placeholder="npr. 30"
                      value={nocniProc}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setNocniProc(v);
                        validateField('nocniProc', v);
                      }}
                      onBlur={(e) => validateField('nocniProc', e.target.value.replace(',', '.'))}
                    />
                    {errors.nocniProc && <div className="error-text">{errors.nocniProc}</div>}
                  </div>
                </>
              )}

              {/* Praznični rad */}
              <div className="field-group">
                <label htmlFor="praznik" className="field-label">
                  Rad za praznik (da/ne):
                </label>
                <select
                  id="praznik"
                  className="field-select"
                  value={praznik ? 'da' : 'ne'}
                  onChange={(e) => {
                    const val = e.target.value === 'da';
                    setPraznik(val);
                    if (!val) {
                      setErrors(prev => ({ ...prev, praznikSati: '', praznikProc: '' }));
                      setPraznikSati('');
                      setPraznikProc('');
                    }
                  }}
                >
                  <option value="ne">Ne</option>
                  <option value="da">Da</option>
                </select>
              </div>
              {praznik && (
                <>
                  <div className="field-group">
                    <label htmlFor="praznikSati" className="field-label">
                      Broj sati odrađenih za vrijeme praznika<span className="required">*</span>:
                    </label>
                    <input
                      type="text"
                      id="praznikSati"
                      className={`field-input ${errors.praznikSati ? 'shake' : ''}`}
                      placeholder="npr. 8"
                      value={praznikSati}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setPraznikSati(v);
                        validateField('praznikSati', v);
                      }}
                      onBlur={(e) => validateField('praznikSati', e.target.value.replace(',', '.'))}
                    />
                    {errors.praznikSati && <div className="error-text">{errors.praznikSati}</div>}
                  </div>
                  <div className="field-group">
                    <label htmlFor="praznikProc" className="field-label">
                      Procenat uvećanja (ostavite prazno za 100%):
                    </label>
                    <input
                      type="text"
                      id="praznikProc"
                      className={`field-input ${errors.praznikProc ? 'shake' : ''}`}
                      placeholder="npr. 100"
                      value={praznikProc}
                      onChange={(e) => {
                        const v = e.target.value.replace(',', '.');
                        setPraznikProc(v);
                        validateField('praznikProc', v);
                      }}
                      onBlur={(e) => validateField('praznikProc', e.target.value.replace(',', '.'))}
                    />
                    {errors.praznikProc && <div className="error-text">{errors.praznikProc}</div>}
                  </div>
                </>
              )}
            </>
          )}
        </div>
          <div ref={printRef} className="print-area">
        {/* ==== DESNI STUPAC: REZULTATI ==== */}
        <div className="results-container card" ref={resultsRef}>
          <h2 className="section-title">Rezultati obračuna</h2>

          {loading && (
            <div className="loader" style={{ display: 'flex', alignItems: 'center' }}>
              <span className="spinner"></span>
              <span>Računam…</span>
            </div>
          )}
          {submitError && <div className="error-text loader">{submitError}</div>}

          {rezultati && !loading && (
            <>
              {/* ======== SEKCIJA 1: OSNOVNI PREGLED ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiCalendar style={{ marginRight: '8px' }} />
                  Podaci o mjesecu
                </h3>
                <div className="result-row">
                  <span>Radni dani u {formatirajDatum()}</span>
                  <span>{rezultati.radni_dani} dana</span>
                </div>
                <div className="result-row">
                  <span>Plaćeni dani (radnik na poslu)</span>
                  <span>{rezultati.dana_radio} dana</span>
                </div>
                <div className="result-row">
                  <span>Radni sati u {formatirajDatum()}</span>
                  <span>{rezultati.mjesec_sati} sati</span>
                </div>
              </div>

              {/* ======== SEKCIJA 6: ODSUSTVA & NEODRAĐENI SATI ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiCalendar style={{ marginRight: '8px' }} />
                  Odsustva i neodrađeni sati
                </h3>
                <div className="result-row">
                  <span>Neplaćeni dani</span>
                  <span>{prikaziDane(neplaceno)} dana</span>
                </div>
                <div className="result-row">
                  <span>Plaćeno odsustvo</span>
                  <span>{prikaziDane(placeno)} dana</span>
                </div>
                <div className="result-row">
                  <span>Neodrađeni sati</span>
                  <span>{rezultati.neradno_vrijeme} sati</span>
                </div>
              </div>

              {/* ======== SEKCIJA 2: DNEVNICE & TOPLI OBROK ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiUserCheck style={{ marginRight: '8px' }} />
                  Dnevnice i topli obrok
                </h3>
                <div className="result-row">
                  <span>Broj dana s dnevnicama</span>
                  <span>{rezultati.dnevnice} dana</span>
                </div>
                <div className="result-row">
                  <span>Dani za topli obrok</span>
                  <span>{rezultati.topli_dani} dana</span>
                </div><div className="result-row">
                  <span>Topli obrok po danu</span>
                  <span>{rezultati.topli_obrok_dan.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Topli obrok</span>
                  <span>{rezultati.topli_obrok.toFixed(2)} KM</span>
                </div>
              </div>

              {/* ======== SEKCIJA 3: POREZ ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiDollarSign style={{ marginRight: '8px' }} />
                  Porez
                </h3>
                <div className="result-row">
                  <span>Porez na dohodak</span>
                  <span>{rezultati.porez.toFixed(2)} KM</span>
                </div>
              </div>

              {/* ======== SEKCIJA 4: NETO PLATA ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiTool style={{ marginRight: '8px' }} />
                  Neto plata
                </h3>
                <div className="result-row">
                  <span><b>Neto plata</b></span>
                  <span><b>{rezultati.neto_plata.toFixed(2)} KM</b></span>
                </div>
                <div className="result-row">
                  <span><b>Neto plata sa toplim obrokom</b></span>
                  <span><b>{(rezultati.neto_plata + rezultati.topli_obrok).toFixed(2)} KM</b></span>
                </div>
              </div>

              {/* ======== SEKCIJA 5: BRUTO & MINULI RAD ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiUserCheck style={{ marginRight: '8px' }} />
                  Bruto plata i ostale naknade
                </h3>
                <div className="result-row">
                  <span>Bruto osnovna plata</span>
                  <span>{rezultati.bruto_plata_osnovna.toFixed(2)} KM</span>
                </div>
                {/* DODATO: Prikaz minulog rada */}
                {rezultati.minuli_rad_iznos > 0 && (
                  <div className="result-row">
                    <span>Minuli rad ({rezultati.minuli_rad_procenat.toFixed(1)}%)</span>
                    <span>{rezultati.minuli_rad_iznos.toFixed(2)} KM</span>
                  </div>
                )}
                <div className="result-row">
                  <span>Bruto osnovna plata s uvećanjima</span>
                  <span>{rezultati.bruto_plata_sa_uvecanjem.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span><b>Ukupni troškovi bruto plate za prijavu</b></span>
                  <span><b>{rezultati.bruto_ukupno.toFixed(2)} KM</b></span>
                </div>
                <div className="result-row">
                  <span>Ukupni troškovi bruto plate sa toplim obrokom</span>
                  <span>{(rezultati.bruto_ukupno + rezultati.topli_obrok).toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Bruto za prijavu bez zdravstva (radnik iz RS/Brčko Dist.)</span>
                  <span>{(rezultati.bruto_ukupno - rezultati.zdravstveno - rezultati.pos_zdravstveno).toFixed(2)} KM</span>
                </div>
              </div>

              {/* ======== SEKCIJA OSTALE NAKNADE ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiTool style={{ marginRight: '8px' }} />
                  Posebne naknade i podsticaj
                </h3>
                <div className="result-row">
                  <span>Posebna naknada za prirodne i dr. nesreće</span>
                  <span>{rezultati.naknada_nesrece.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Opšta vodna naknada</span>
                  <span>{rezultati.naknada_voda.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Podsticaj za zapošljavanje invalida</span>
                  <span>{rezultati.naknada_invalidi.toFixed(2)} KM</span>
                </div>
              </div>

              {/* ======== SEKCIJA 7: DOPRINOSI poslodavac ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiDollarSign style={{ marginRight: '8px' }} />
                  Doprinosi na teret poslodavca
                </h3>
                <div className="result-row">
                  <span>PIO</span>
                  <span>{rezultati.pos_PIO.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Zdravstveno</span>
                  <span>{rezultati.pos_zdravstveno.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Nezaposlenost</span>
                  <span>{rezultati.pos_nezaposlenost.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span><b>Doprinosi ukupno</b></span>
                  <span><b>{rezultati.pos_doprinosi.toFixed(2)} KM</b></span>
                </div>
              </div>

              {/* ======== SEKCIJA 7: DOPRINOSI ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiDollarSign style={{ marginRight: '8px' }} />
                  Doprinosi na teret zaposlenika
                </h3>
                <div className="result-row">
                  <span>PIO</span>
                  <span>{rezultati.PIO.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Zdravstveno</span>
                  <span>{rezultati.zdravstveno.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Nezaposlenost</span>
                  <span>{rezultati.nezaposlenost.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span><b>Doprinosi ukupno</b></span>
                  <span><b>{rezultati.doprinosi_ukupno.toFixed(2)} KM</b></span>
                </div>
              </div>

              {/* ======== SEKCIJA 7: DOPRINOSI ======== */}
              <div className="results-section">
                <h3 className="subsection-title">
                  <FiDollarSign style={{ marginRight: '8px' }} />
                  Rekapitulacija (uplatnice)
                </h3>
                <div className="result-row">
                  <span>PIO</span>
                  <span>{(rezultati.PIO + rezultati.pos_PIO).toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Zdravstvo Federacija 10.20%</span>
                  <span>{((rezultati.zdravstveno + rezultati.pos_zdravstveno) * 0.102).toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Zdravstvo kanton 89.90%</span>
                  <span>{((rezultati.zdravstveno + rezultati.pos_zdravstveno) * 0.898).toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Nezaposlenost Federacija 30%</span>
                  <span>{((rezultati.nezaposlenost + rezultati.pos_nezaposlenost) * 0.3).toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Nezaposlenost kanton 70%</span>
                  <span>{((rezultati.nezaposlenost + rezultati.pos_nezaposlenost) * 0.7).toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Porez na dohodak</span>
                  <span>{rezultati.porez.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Posebna naknada za prirodne i dr. nesreće</span>
                  <span>{rezultati.naknada_nesrece.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Opšta vodna naknada</span>
                  <span>{rezultati.naknada_voda.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span>Podsticaj za zapošljavanje invalida</span>
                  <span>{rezultati.naknada_invalidi.toFixed(2)} KM</span>
                </div>
                <div className="result-row">
                  <span><b>Ukupno</b></span>
                  <span><b>{(rezultati.doprinosi_ukupno + rezultati.pos_doprinosi + rezultati.porez + rezultati.naknada_nesrece + rezultati.naknada_voda + rezultati.naknada_invalidi).toFixed(2)} KM</b></span>
                </div>
              </div>

              {/* ======== SEKCIJA 8: DODACI (prekovremeni, noćni, praznik) ======== */}
              {imaPreko && (
                <div className="results-section">
                  <h3 className="subsection-title">
                    <FiTool style={{ marginRight: '8px' }} />
                    Dodaci (prekovremeni, noćni, praznik)
                  </h3>
                  {prekovremeni && (
                    <div className="result-row">
                      <span>Prekovremeni sati</span>
                      <span>{rezultati.prekovremeni_sati} sati</span>
                    </div>
                  )}
                  {nocni && (
                    <div className="result-row">
                      <span>Noćni sati</span>
                      <span>{rezultati.nocni_sati} sati</span>
                    </div>
                  )}
                  {praznik && (
                    <div className="result-row">
                      <span>Praznični sati</span>
                      <span>{rezultati.praznik_sati} sati</span>
                    </div>
                  )}
                  <div className="result-row">
                    <span>Ukupno povećanje bruto osnovne plate</span>
                    <span>{rezultati.ukupno_uvecanje.toFixed(2)} KM</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        </div>
      </div>
    </>
  );
}

export default App;
